import React from "react";
import { useSelector } from "react-redux";
import userAvatar from "../../../assets/images/Chat-avatar.png";
import { getLiveStream } from "../../../store/social/social.selector";
import { getImage } from "../../../store/user/user.selector";
import { chatList as audience } from "../MarketplaceData/MarketplaceData";

const Audience = () => {
    const { livestream } = useSelector((state) => {
        return {
            livestream: getLiveStream(state),
        };
    });

    return (
        <div className="h-[calc(100vh_-_175px)] overflow-y-auto">
            <div className="flex items-center justify-start mx-1 mt-4 mb-6">
                <img
                    src={getImage(livestream.owner.attachments)}
                    alt=""
                    className="rounded-full w-[35px] aspect-square mr-2.5"
                />
                <div className="">
                    <h4 className="text-sm font-medium text-ebony-color capitalize">
                        {livestream.owner.fullName}
                    </h4>
                    <p className="text-[10px] text-black-50">
                        @{livestream.owner.userName}
                    </p>
                </div>
            </div>
            <div className="">
                <h3 className="text-sm font-medium text-ebony-color mb-4">
                    {livestream.guestInfo && livestream.guestInfo.length} joined
                    this live
                </h3>

                {livestream.guestInfo &&
                    livestream.guestInfo.map((user) => {
                        return (
                            <div
                                key={user.id}
                                className="py-[3px] pl-1.5 pr-4 flex items-center justify-start rounded-md border border-black-10 mb-2.5 cursor-pointer"
                            >
                                <img
                                    src={getImage(user.attachments)}
                                    alt=""
                                    className="rounded-full w-[35px] aspect-square mr-2.5"
                                />
                                <h4 className="text-sm font-medium text-ebony-color capitalize">
                                    {user.fullName}
                                </h4>
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};

export default Audience;
